import styled from "styled-components";

export const StyledContainerProfessionalWay = styled.div`
  margin-top: 12px;
`;
